import './css/Location.css';

import gill_logo from './images/gill_logo.jpg';
import facade from './images/facade.jpg';

function Location() {
    return (
        <div className="location">
          <div className="location-header">
            <h1>Contact Us</h1>
            <div className="logo-wrapper">
              <img src={gill_logo} alt="Gill Associates Photography - A Full Service studio"/>
            </div>
            <div className="contact-details">
                <div className="business-name">Gill Associates Photography Studio</div>
                <div className="phone">Phone: 516.676.1833</div>
                <div className="email">Email: <a href="mailto:agallego@gillassoc.com">agallego@gillassoc.com</a></div>
                <div className="address">
                  <h3>Address:</h3>
                  <div>58 School Street</div>
                  <div>Glen Cove,  New York 11542</div>
                </div>
            </div>
          </div>
          <div className="facade">
            <img src={facade} alt="Gill Associates Photography - A Full Service studio"/>
          </div>
          <div className="map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3017.273525209976!2d-73.63274458475327!3d40.86587117931548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c28574c9a3da6d%3A0xce44062135b1ea7f!2s58%20School%20St%2C%20Glen%20Cove%2C%20NY%2011542!5e0!3m2!1sen!2sus!4v1612096949717!5m2!1sen!2sus" title="Gill Associaates Photography - 58 School Street, Glen Cove, NY11542"></iframe>
          </div>
        </div>
    );
}

export default Location;
